var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9604"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 25184"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#0e2240"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.563 9.454h-.875a.45.45 0 0 0-.437.438v2.919a.45.45 0 0 1-.437.438H3.188a.45.45 0 0 1-.437-.438V9.892a.45.45 0 0 0-.438-.438h-.875A.45.45 0 0 0 1 9.892v3.941a1.17 1.17 0 0 0 1.167 1.168h11.666A1.17 1.17 0 0 0 15 13.833V9.892a.45.45 0 0 0-.437-.438",
  "data-name": "Path 4401"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.694 11.392a.42.42 0 0 0 .612 0l3.936-3.941a.424.424 0 0 0 0-.613l-.612-.613a.42.42 0 0 0-.612 0L9.385 7.86a.292.292 0 0 1-.5-.2V1.438A.524.524 0 0 0 8.423 1h-.875a.45.45 0 0 0-.437.438v6.188a.292.292 0 0 1-.5.2L4.983 6.2a.42.42 0 0 0-.612 0l-.612.642a.424.424 0 0 0 0 .613Z",
  "data-name": "Path 4402"
})))));
export { SvgDownload as ReactComponent };
export default "/_next/static/images/download.svg";